// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import type { SchemaMigration } from '../types'
import { migration as v002 } from './002-add-description'

export const missionsMigrations: SchemaMigration[] = [v002]
